// i18n area 'system' — locale lv-LV (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/system.lv-LV.meta.json.
import type { enUS } from './system'

export const lvLV: typeof enUS = {
  diagnostics: {
    title: 'Diagnostika',
    subtitle: 'Kas nav kārtībā, sliktākais vispirms — tā pati lēca kā tvirt diagnose',
    reload: 'Pārlādēt',
    loadError: 'Diagnozi neizdevās nolasīt',
    exportBundle: 'Eksportēt pakotni',
    exportError: 'Pakotni neizdevās izveidot',
    noProblem: 'Pārbaudītajās jomās problēmu nav',
    nothingInspected: 'NEKAS netika pārbaudīts — tas nav veselības apliecinājums',
    inspected: 'Pārbaudītas',
    notInspected: 'NAV pārbaudītas',
    localHint: 'Mezgla lokālās jomas (systemd vienības, žurnāls) lasāmas tikai no CLI: tvirt diagnose --area local — ceļš, kad API neatbild.',
    thresholds: 'neizdevušies uzdevumi {hours} h laikā, heartbeat kavējas vairāk par {seconds} s',
    severity: {
      critical: 'Kritisks',
      warning: 'Brīdinājums',
      unknown: 'Nezināms'
    }
  },
  explorer: {
    title: 'Pārlūkot resursus',
    root: 'Sakne',
    empty: 'Šajā scope nav neviena resursa',
    previewHint: 'Jāizvēlas objekts, lai redzētu tā priekšskatījumu',
    open: 'Atvērt',

    // CRUD sarakstu dziļā saite ?scope= (kārta #109), no pārlūka (#143).
    openScoped: 'Atvērt sarakstu šajā scope',
    kinds: {
      vm: 'VM',
      vmTemplate: 'VM template',
      ct: 'CT',
      ctTemplate: 'CT template',
      app: 'Lietotne',
      overlayNetwork: 'Overlay tīkls',
      networkService: 'Tīkla pakalpojums',
      fabric: 'Fabric',
      subnet: 'Apakštīkls',
      storage: 'Storage pūls',
      disk: 'Disks',
      catalogFile: 'Kataloga fails',
      ociRegistry: 'OCI registry',
      ociImage: 'OCI attēls',
      cephCluster: 'Ceph klasteris',
      backupDestination: 'Dublējumu mērķis',
      user: 'Lietotājs',
      group: 'Grupa',
      role: 'Loma',
      credential: 'Akreditācijas dati',
      tag: 'Tags',
      proximityRule: 'Proximity noteikums'
    }
  },
  tags: {
    title: 'Tagi',
    empty: 'Nav neviena taga',
    add: 'Pievienot tagu',
    remove: 'Noņemt',
    name: 'Tags',
    value: 'Vērtība',
    save: 'Saglabāt',
    saveError: 'Neizdevās saglabāt tagus',
    loadError: 'Neizdevās ielādēt tagu vārdnīcu',
    noVocabulary: 'Šim resursa tipam nav pieejams neviens tags',

    // Jau piešķirts vienas vērtības tags atbild ar 409: aizstāšana vienmēr ir
    // eksplicīta — nekad ne netieša nomaiņa (dizains, ratificēts 2026-07-27).
    overwrite: 'Aizstāt pašreizējo vērtību',

    // Sistēma > Tagi, vārdnīcas virsma.
    createTitle: 'Izveidot tagu',
    editTitle: 'Rediģēt tagu',
    nameHint: 'Burti, cipari, punkti, defises un pasvītrojumi — nekādu ":" un "/"; prefikss tvirt- ir rezervēts platformai',
    cardinality: 'Kardinalitāte',
    cardinalitySingle: 'Tikai viena vērtība',
    cardinalityMultiple: 'Vairākas vērtības',
    cardinalityHint: 'Ar vienu vienīgu vērtību taga atkārtota piešķiršana prasa to aizstāt',
    autoCreate: 'Vērtību automātiska izveide',
    autoCreateOn: 'Piešķiršanas brīdī',
    autoCreateOff: 'Tikai deklarētās',
    autoCreateHint: 'Ieslēgts: piešķirot jaunu vērtību, tā tiek izveidota. Izslēgts: piešķir tikai deklarētās vērtības',
    values: 'Vērtības',
    noValues: 'Nav deklarēta neviena vērtība',
    addValue: 'Pievienot vērtību',
    duplicateValue: 'Dublēta vērtība',
    kinds: 'Resursu tipi',
    kindsAll: 'Visi',
    kindsPlaceholder: 'Visi',
    kindsHint: 'Jāatstāj tukšs, lai pieļautu jebkuru tagojamu resursa tipu',
    systemChip: 'Sistēma',
    deleteCascade: 'Noņemt arī piešķīrumus',
    deleteCascadeHint: 'Tags, kas joprojām ir piešķirts kādam resursam, tiek noraidīts: ar šo opciju vērtības un visi piešķīrumi aiziet kopā ar tagu.'
  },
  scopes: {
    title: 'Scope',
    createTitle: 'Izveidot scope',
    editTitle: 'Pārdēvēt scope',
    path: 'Ceļš',
    segment: 'Segments',
    segmentHint: 'Mazie burti, cipari un defises (DNS-1123)',
    parent: 'Vecāks',
    rootChip: 'Sakne',
    preview: 'Jaunais scope',
    pickLabel: 'Scope',
    pickHint: 'Kur objekts mīt klastera kokā — saknē vai kādā vDC tās iekšienē.',
    ociCache: 'OCI kešatmiņa (override)',
    appEphemeral: 'Lietotņu īslaicīgie pūli (override)',
    inherit: 'Pārmantot',
    inheritsFrom: 'Pārmanto no',
    inheritsCluster: 'Pārmanto klastera noklusējumu',
    inheritsNone: 'Pārmanto — nav neviena efektīva pūla',
    failoverProtection: 'Aizsardzība degradētā klasterī',
    networkWeight: 'Tīkla svars',
    networkCeil: 'Tīkla griesti (Mbps)',
    protectionProtected: 'Aizsargāta',
    protectionExpendable: 'Upurējama degradācijā',
    protectionDefault: 'Klastera noklusējums'
  },

  // Sistēma > Informācija (kārta #124, 2026-07-31): platformas versijas flotē
  // (atjaunināšanas vidū ne vairāk kā divas), komponentes katram mezglam,
  // lokāli pasniegta PDF rokasgrāmata un iekļautā licences karte.
  sysinfo: {
    summary: 'Platformas versijas klasterī, katra mezgla komponentes, administrēšanas rokasgrāmata un licence.',
    platformTitle: 'TVirt platforma',
    platformSubtitle: 'Klastera mezglos novērotās versijas',
    versionOnNodes: '{version} uz {n} mezgliem',
    versionOnOneNode: '{version} uz 1 mezgla',
    mixedVersions: 'Klasterī ir vairāk nekā viena platformas versija — tas ir gaidāms tikai notiekošas atjaunināšanas laikā (ne vairāk kā divas).',
    tooManyVersions: 'Klasterī ir vairāk nekā divas platformas versijas — tas nav gaidāms nekad, pat atjaunināšanas laikā ne: jāpārbauda zemāk esošie mezgli.',
    unreportedNodes: 'Vēl nav neviena versiju ziņojuma no: {nodes}',
    noVersionsYet: 'Neviens mezgls vēl nav paziņojis savas versijas.',
    nodesUnavailable: 'Ar jūsu atļaujām mezglu saraksts nav redzams — platformas versijas nevar parādīt.',
    colNode: 'Mezgls',
    manualTitle: 'Administrēšanas rokasgrāmata',
    manualSubtitle: 'Lokāla kopija, ko pasniedz šis klasteris',
    manualBody: 'Pilnā TVirt rokasgrāmata PDF formātā, ko pasniedz pati platforma — pieejama arī air-gapped vidēs.',
    manualLink: 'Administrēšanas rokasgrāmata (PDF)',
    apiExplorerTitle: 'API pārlūks',
    apiExplorerSubtitle: 'OpenAPI kontrakts, pārlūkojams',
    apiExplorerBody: 'Platformas pilnais OpenAPI kontrakts — katrs maršruts, shēma un atbildes kods — pārlūkojams no pārlūkprogrammas, pasniegts caur šo mezglu.',
    apiExplorerLink: 'Izpētīt API',
    kubeTitle: 'Saderība ar Kubernetes',
    kubeSubtitle: 'kubectl un tā rīki natīvā API priekšā',
    kubeBody: 'TVirt KubeCompat projicē Pod, Deployment, Service objektus, vārdtelpas, mezglus un notikumus Kubernetes dialektā — tikai lasīšanai, plus Deployment dzēšana. Katrs izsaukums iet caur natīvo API ar tavām atļaujām: kubeconfig failā izmanto app token kā bearer.',
    kubeEndpoint: 'Endpoint priekš kubectl',
    kubeStatusActive: 'Aktīvs — Kubernetes {version}',
    kubeStatusMissing: 'Nav instalēts šajā mezglā (pakotne trantor-tvirt-kubecompat)',
    kubeStatusDown: 'Instalēts, bet neatbild — pārbaudi vienību trantor-tvirt-kubecompat',
    kubeStatusChecking: 'Pārbauda…'
  },

  // Licencēšana (kārta 2026-07-29): abonementa licences lapa.
  licensing: {
    title: 'Klastera licence',
    subtitle: 'Abonementa licence — ne vairāk kā viena uz klasteri',
    absentTitle: 'Nav reģistrēta neviena licence',
    absentBody:
      'Bez derīgas licences klasteris atsakās startēt jaunas virtuālās mašīnas (ieslēgtās VM paliek ieslēgtas). Jāreģistrē produkta atslēga, kas saņemta kopā ar abonementu.',
    registerButton: 'Reģistrēt licenci',
    removeButton: 'Noņemt licenci',
    state: {
      ok: 'Derīga',
      limitExceeded: 'Pārsniegts limits',
      expired: 'Beigusies'
    },
    productKeyLabel: 'Produkta atslēga',
    basisLabel: 'Limita bāze',
    basis: {
      concurrentVms: 'Vienlaikus ieslēgtās VM',
      physicalCores: 'Fiziskie kodoli (klastera kopskaits)'
    },
    limitLabel: 'Limits',
    usageLabel: 'Pašreizējais lietojums',
    usageOf: '{used} no {limit}',
    usagePartial: 'daļēja summa — {n} mezglam(-iem) nav novērotas CPU topoloģijas',
    usageUnknown: 'pašlaik nav novērojams',
    expiresLabel: 'Derīguma termiņš',
    neverExpires: 'nekad',
    registeredLabel: 'Reģistrēta',
    gateNote:
      'Ja licences nav, tā ir beigusies vai limits ir pārsniegts, klasteris atsakās startēt JAUNAS virtuālās mašīnas. Ieslēgtās VM paliek ieslēgtas, un HA pārstartēšanas no tā necieš.',
    devStage:
      'Izstrādes stadija: produkta atslēga tiek pieņemta tāda, kāda tā ir, kopā ar šeit deklarētajiem limitiem; validācija ar parakstītu atslēgu ienāks kādā nākotnes laidienā.',
    dialogTitle: 'Reģistrēt licenci',
    dialogExpiresHelp: 'Tukšs = licencei nav derīguma termiņa',
    dialogSubmit: 'Reģistrēt',
    dialogError: 'Neizdevās reģistrēt licenci.',
    removeTitle: 'Noņemt licenci',
    removeBody:
      'Klasteris paliks BEZ LICENCES: jaunas virtuālās mašīnas atteiksies startēt, kamēr netiks reģistrēta cita. Ieslēgtās VM paliek ieslēgtas.',
    removeConfirm: 'Noņemt',
    removeError: 'Neizdevās noņemt licenci.'
  },
  rbac: {
    tabRoles: 'Lomas',
    tabGrants: 'Deleģējumi',
    rolesTitle: 'Lomas',
    createRoleTitle: 'Izveidot lomu',
    editRoleTitle: 'Rediģēt lomu',
    nameHint: 'Mazie burti, cipari un defises; prefikss tvirt- ir rezervēts',
    systemChip: 'Sistēma',
    permissions: 'Atļaujas',
    permissionsPlaceholder: 'Pievienot atļauju…',
    includedRoles: 'Iekļautās lomas',
    includedRolesPlaceholder: 'Pievienot lomu…',
    grantsTitle: 'Deleģējumi',
    createGrantTitle: 'Izveidot deleģējumu',
    principal: 'Principal',
    principalKind: 'Principal tips',
    principalUser: 'Lietotājs',
    principalGroup: 'Grupa',
    role: 'Loma',
    grantRight: 'Deleģēšana',
    grantRightChip: 'Var deleģēt',
    grantRightLabel: 'Ar deleģēšanas tiesībām (saņēmējs savukārt var deleģēt šo lomu)',
    effective: 'Spēkā',
    notEffective: 'Nav spēkā',
    createdAt: 'Izveidots',
    scopeHint: 'precīzs /path, rekursīvs /path/* — deleģējumi noenkurojas montētā saknē (/* nav deleģējams)'
  },
  groups: {
    title: 'Grupas',
    createTitle: 'Izveidot grupu',
    nameHint: 'Mazie burti, cipari un defises; unikāls scope ietvaros',
    members: 'Dalībnieki',
    membersTitle: 'Dalībnieki',
    membersPlaceholder: 'Pievienot lietotāju…',
    noMembers: 'Nav neviena dalībnieka',
    realmMappings: 'Realm kartējumi',
    realmMappingsTitle: 'Realm kartējumi',
    realmMappingsHint:
      'Kam šī grupa atbilst katrā ārējā realm. Piederība tiek nolasīta no direktorija pieteikšanās brīdī: direktorija grupa, ko šeit neviens nekartē, tiek ignorēta, un ligzdošana netiek atrisināta — tā jāizlīdzina direktorija pusē.',
    realm: 'Realm',
    externalGroup: 'Ārējā grupa',
    addRealmMapping: 'Pievienot kartējumu',
    removeRealmMapping: 'Noņemt kartējumu',
    noRealmMappings: 'Nav neviena realm kartējuma',

    // Izveides dialogs pa sadaļām (kārta realm-wizard, 2026-08-03): Vispārīgi
    // plus kartēšanas virsma ar ārējiem realm un runīgu tukšo stāvokli.
    sectionGeneral: 'Vispārīgi',
    mappingsNoRealms: 'Nav konfigurēts neviens ārējais realm — kartēšanas virsma atveras, tiklīdz kāds realm eksistē.',
    mappingsNoRealmsLink: 'Atvērt cilni Realm un SSO',

    // Grupas uzliktais MFA pienākums (raunds #178, puse B): tīrs OR — grupa
    // pienākumu var tikai PIEVIENOT, nekad noņemt.
    mfaRequired: 'MFA pienākums',
    mfaRequiredChip: 'Uzliek MFA',
    mfaNotRequiredChip: 'Nav pienākuma',
    mfaRequiredHint:
      'Tīrs OR: grupa var PIEVIENOT otrā faktora pienākumu saviem dalībniekiem — arī ārējām identitātēm, caur realm kartējumiem —, bet nekad to noņemt. Tas ir spēkā no nākamās pieteikšanās: atvērtās sesijas netiek slēgtas.'
  },
  users: {
    title: 'Lietotāji',
    createTitle: 'Izveidot lietotāju',
    editTitle: 'Rediģēt lietotāju',
    username: 'Lietotājvārds',
    usernameHint: 'Mazie burti, cipari, punkti un defises',
    displayName: 'Attēlojamais vārds',
    enabled: 'Iespējots',
    state: 'Stāvoklis',
    enabledChip: 'Iespējots',
    disabledChip: 'Atspējots',
    lockedChip: 'Bloķēts',
    password: 'Parole',
    passwordSetChip: 'Iestatīta',
    mustChangeChip: 'Jāmaina',
    initialPassword: 'Sākotnējā parole',
    initialPasswordHint: 'Lietotājam tā būs jānomaina pirmajā pieteikšanās reizē',
    lastLogin: 'Pēdējā pieteikšanās',
    neverLoggedIn: 'Nekad nav pieteicies',
    setPasswordTitle: 'Iestatīt paroli',
    setPasswordHint: 'Administratīva aizstāšana — prasa jūsu paroli (sudo režīms) un liek lietotājam to nomainīt nākamajā pieteikšanās reizē.',
    operatorPassword: 'Jūsu parole',
    unlock: 'Atbloķēt kontu',
    revokeTitle: 'Atsaukt sesijas',
    revokeBody: 'Visas šī lietotāja aktīvās sesijas tiek nekavējoties izbeigtas.',
    revokeIncludeTokens: 'Atsaukt arī lietotņu token',
    revokeConfirm: 'Atsaukt',

    // Standarta dialogs (kārta #156): pilnas detaļas, konta/drošības cilnes.
    tabAccount: 'Konts',
    tabSecurity: 'Drošība',
    usernameImmutableHint: 'Lietotājvārds ir konta identitāte — fiksēts izveides brīdī',
    groups: 'Grupas',
    noGroups: 'Nav nevienas grupas',
    mustChangePassword: 'Obligāta paroles maiņa',
    failedAttempts: 'Neizdevušies pieteikšanās mēģinājumi',
    lockedUntil: 'Bloķēts līdz',

    // Identitātes cilnes (2026-08-03): Sistēma > Lietotāji ir kļuvusi par
    // sadaļu ar cilnēm pēc /system/rbac parauga — lietotāji, grupas, ārējie realm.
    tabUsers: 'Lietotāji',
    tabGroups: 'Grupas',
    tabRealms: 'Realm un SSO',
    tabMfa: 'MFA',

    // MFA cilne (task #178, A puse — GUI uz esošā contract): otrā faktora skats
    // katram lietotājam. Ārējo identitāšu reģistrācijas un bāreņa stāvoklis ir
    // B puse — contract kārta, nekad forma bez backend.
    mfa: {
      title: 'Otrais faktors (MFA)',
      methodsTitle: 'Pieejamās metodes',
      methodsSubtitle: 'Tas, ko šī instalācija prot pārbaudīt kā otro faktoru',
      methodsError: 'Neizdevās ielādēt metožu reģistru',
      builtinChip: 'Iebūvēts',
      enrollableChip: 'Reģistrācija TVirt',
      delegatedChip: 'Pārvaldīts ārēji',
      state: 'Stāvoklis',
      stateActive: 'Aktīvs',
      statePending: 'Gaida reģistrāciju',
      stateNone: 'Nav reģistrēts',
      required: 'MFA pienākums',
      requiredChip: 'Obligāts',
      notRequiredChip: 'Nav obligāts',
      enrolledAt: 'Reģistrēts',
      enrolledMethods: 'Reģistrētās metodes',
      noMethods: 'Nav nevienas reģistrācijas',
      codesRemaining: 'Atlikušie atkopšanas kodi',
      resetTitle: 'Atiestatīt otro faktoru',
      resetHint:
        'Reģistrācija un visi atkopšanas kodi tiek nodzēsti: nākamajā pieteikšanās reizē lietotājs reģistrēsies no jauna. MFA pienākums paliek, kāds bijis — administrators nekad neiestata noslēpumu, tas to tikai atiestata.',
      resetConfirm: 'Atiestatīt',
      resetError: 'Neizdevās atiestatīt otro faktoru',
      empty: 'Vēl nav neviena pārvaldīta lietotāja — konti parādās šeit, tiklīdz eksistē, katrs ar savu otrā faktora stāvokli.',

      // Puse B (raunds #178): spēkā esošā sprieduma izcelsme, ārējās
      // reģistrācijas ar bāreņa stāvokli, grupas, kas uzliek pienākumu.
      viaSelf: 'Personisks',
      viaSelfHint: 'Konta personiskais ieguldījums (tā karodziņš) — vienīgā daļa, ko rediģē zīmulis.',
      viaGroupHint: 'No šīs grupas mantots pienākums: personiskā karodziņa noņemšana lietotāju neatbrīvo — jārīkojas grupā, cilnē Grupas.',
      subject: 'Identitāte',
      lastSeenAt: 'Pēdējais apstiprinājums',
      enrollmentPending: 'Gaida',
      orphanChip: 'Bārene',
      orphanDirectoryMiss: 'Identitātes vairs nav direktorijā',
      orphanRealmRemoved: 'Realm tika noņemts no TVirt',
      orphanedAt: 'Bārene kopš',
      directoryUuid: 'UUID direktorijā',
      externalTitle: 'Ārējās reģistrācijas',
      externalEmpty: 'Vēl nav nevienas ārējās reģistrācijas — tā rodas pirmajā pieteikšanās reizē direktorija identitātei ar MFA pienākumu.',
      orphanHelp:
        'Bārenes reģistrācija nekad neizdzēšas pati: tas ir drošības materiāls — tā paliek auditam, un, ja identitāte atkal parādās direktorijā, tā atgūst savu faktoru. Vienīgā izeja ir administratīvā atiestatīšana.',
      visibilityHint: 'Ārējās reģistrācijas mīt klastera saknē: tās redz tikai tas, kam ir user.read pār visu koku.',
      orphanResetHint:
        'Bārenes rinda tiek noņemta pavisam: neviens to vairs nepieprasa. Ja identitāte atgriezīsies direktorijā, tā reģistrēsies no jauna.',
      enforcingTitle: 'Grupas, kas uzliek MFA',
      enforcingSubtitle:
        'Pienākuma enkurs ārējām identitātēm ir grupa: tās realm kartējumi pasaka, kuru direktorija populāciju tas sasniedz. Ārējā reģistrācija rodas pienākumam pakļautā lietotāja pirmajā pieteikšanās reizē.',
      enforcingEmpty: 'Neviena grupa neuzliek MFA — pienākumu ieslēdz grupā, cilnē Grupas.',
      enforcingError: 'Neizdevās ielādēt grupas, kas uzliek MFA'
    }
  },
  realms: {
    title: 'Autentifikācijas realm',
    createTitle: 'Izveidot realm',
    editTitle: 'Rediģēt realm',
    name: 'Realm',
    nameHint: 'Domēns, ko lietotāji raksta aiz @ (example.com) — pēc izveides nemaināms',
    nameImmutableHint: 'Realm nosaukums ir iespiests katrā sesijā un katrā audita rindā, kas to jebkad nosaukusi — pārdēvēšana pārrakstītu vēsturi',
    kind: 'Tips',
    kindLdap: 'LDAP / Active Directory',
    kindHint: 'OIDC un SAML ienāks nākamajās kārtās — šodien realm ir LDAPv3 direktorijs',

    // Izveides pusvednis (kārta realm-wizard, 2026-08-03): 1. soļa tipu kartes —
    // ldap dzīvs, oidc/saml kartes attīstības plānā (nekad forma bez backend).
    kindCategory: 'Realm tips',
    kindSelectHint: 'Jāizvēlas direktorija tips, kurā šis realm autentificēs.',
    kindCard: {
      ldap: {
        name: 'LDAP / Active Directory',
        desc: 'Lietotājvārds un parole, pārbaudīti ar bind pret LDAPv3 direktoriju — Active Directory, FreeIPA, OpenLDAP.'
      },
      oidc: {
        name: 'OpenID Connect',
        desc: 'Single sign-on no pārlūka, deleģēts OpenID Connect identitātes nodrošinātājam — ienāks nākamajās kārtās.'
      },
      saml: {
        name: 'SAML 2.0',
        desc: 'Uzņēmuma single sign-on ar SAML 2.0 apgalvojumiem — ienāks nākamajās kārtās.'
      }
    },
    tabBind: 'Bind',
    enabled: 'Iespējots',
    urls: 'Direktorija serveri',
    urlsHint: 'Viens ldap:// vai ldaps:// URL rindā (1–8), izmēģināti pēc kārtas — failover, nekad ne balansēšana',
    startTls: 'StartTLS',
    verifyCertificate: 'Pārbaudīt sertifikātu',
    cleartextWarning: 'Bez ldaps:// vai StartTLS bind parole šķērso tīklu atklātā tekstā — pieņemami laboratorijā, nekad ražošanā.',
    noVerifyWarning: 'Nepārbaudīta TLS sesija neautentificē nevienu: pārbaudi drīkst izslēgt tikai pret direktoriju, ko nav iespējams salabot.',
    caCertificate: 'CA sertifikāts (PEM)',
    caCertificateHint: 'Neobligāts CA komplekts, piesaistīts šī realm TLS/StartTLS handshake; tukšs to noņem',
    caCertificatePinned: 'Piesaistīts',
    connectTimeout: 'Noildze (sekundēs)',
    connectTimeoutHint: 'Savienojuma un pieprasījuma termiņš katram URL (1–60); pēc tā beigām tiek izmēģināts nākamais URL',
    bindDn: 'Bind DN',
    bindDnHint: 'Pakalpojuma konts, kas veic lietotāja meklēšanu; tukšs = anonīms search bind (AD to atsaka)',
    anonymousBind: 'Anonīms search bind',
    bindCredential: 'Bind parole (keystore)',
    bindCredentialHint: 'Keystore usernamePassword ieraksts ar bind paroli — noslēpums nekad nemīt realm iekšienē',
    bindCredentialNone: 'Nav (anonīms bind)',
    bindCredentialEmpty: 'Keystore nav neviena usernamePassword ieraksta — bind parolei tāds jāizveido sadaļā Sistēma > Akreditācijas dati.',
    baseDn: 'Base DN',
    baseDnHint: 'Apakškoks, no kura sākas lietotāja meklēšana (DC=example,DC=com)',
    userFilter: 'Lietotāja filtrs',
    userFilterHint: '%u tiek aizstāts ar pieteikšanās vārda lokālo daļu, ar RFC 4515 ekranēšanu; ne-AD direktoriji parasti grib (&(objectClass=inetOrgPerson)(uid=%u))',
    memberOfAttribute: 'memberOf atribūts',
    memberOfAttributeHint: 'Nolasīts vienu vienīgu reizi, pieteikšanās brīdī — nekartētās grupas tiek ignorētas, ligzdošana netiek atrisināta',
    uuidAttribute: 'UUID atribūts',
    uuidAttributeHint: 'Realm ietvaros nemainīgais UUID (objectGUID uz AD, entryUUID uz OpenLDAP) — iespiests auditā līdzās lietotājs@realm',
    displayNameAttribute: 'Attēlojamā vārda atribūts',
    displayNameAttributeHint: 'Izmantots, lai sasveicinātos ar lietotāju; ja tā trūkst, tiek lietots pieteikšanās vārds',
    sudoHint: 'Rakstīšana realm ir sudo aizsargāta: realm ir ieejas durvis platformā',
    deleteBody: 'Realm grupu kartējumi aiziet līdzi tam; sesijas, ko tas autentificējis, paliek dzīvas līdz termiņa beigām — dzēsts realm vienkārši vairs nevienu neielaiž.',
    tabConnection: 'Savienojums',
    tabDirectory: 'Direktorijs',
    testTitle: 'Pārbaudīt savienojumu',
    testHint: 'Konfigurācijas zonde, nekad ne autentifikācija: tā izveido savienojumu, veic bind ar pakalpojuma kontu un — ja norādīts lietotājvārds — izpilda lietotāja filtru.',
    testUsername: 'Lietotājvārds (neobligāts)',
    testUsernameHint: 'Lokālā daļa, uz kuras izpildīt lietotāja filtru — 1 atbilsme ir veselīgā atbilde',
    testRun: 'Izpildīt pārbaudi',
    testError: 'Neizdevās izpildīt zondi',
    testReachable: 'Direktorijs sasniedzams, pakalpojuma bind pieņemts',
    testUnreachable: 'Direktorijs NAV sasniedzams',
    matchedOne: 'Lietotāja filtrs atrada tieši 1 ierakstu — veselīgā atbilde.',
    matchedNone: 'Lietotāja filtrs neatrada nevienu ierakstu: nepareizs ir vai nu filtrs, vai base DN.',
    matchedMany: 'Lietotāja filtrs atrada {count} ierakstus: tas nav selektīvs, un pieteikšanās būtu neviennozīmīga (atteikta).',
    mappingsPointer: 'Tas, kam atbilst ārējā grupa, ir TVirt grupas īpašība (tās realm kartējumi): patiesības punkts mīt cilnē Grupas.',
    mappingsPointerLink: 'Atvērt cilni Grupas',
    rootHomeHint: 'Ārējā realm identitātes mīt klastera saknē, nekad kādā vDC: atļaujas piešķir tur, kur tās vajadzīgas, ar deleģējumiem — grupai vai tieši lietotājam, tieši tāpat kā natīvajām.'
  },
  credentials: {
    title: 'Akreditācijas dati',
    createTitle: 'Izveidot akreditācijas datus',
    editTitle: 'Rediģēt akreditācijas datus',
    kind: 'Tips',
    kindUsernamePassword: 'Lietotājvārds un parole',
    kindIscsiChap: 'CHAP (iSCSI)',
    kindNvmeDhchap: 'DH-HMAC-CHAP (NVMe)',
    kindCephx: 'cephx (Ceph identitāte)',
    kindHintUsernamePassword: 'Nemainīgs. CIFS/SMB storage — montēšanas konts, kura noslēpumu worker izmanto montēšanas brīdī.',
    kindHintIscsiChap: 'Nemainīgs. iSCSI CHAP autentifikācijai — username = CHAP nosaukums, secret = CHAP noslēpums.',
    kindHintNvmeDhchap: 'Nemainīgs. NVMe over Fabrics DH-HMAC-CHAP vajadzībām — secret = DHHC-1:xx:… blobs; username ir tikai etiķete.',
    kindHintCephx: 'Nemainīgs. Ceph klientiem — username = klienta nosaukums (client.…), secret = base64 atslēga.',
    kindImmutableHint: 'Tips pēc izveides ir nemainīgs — to mainīt nozīmē jaunus akreditācijas datus.',
    username: 'Lietotājvārds',
    usernameChap: 'CHAP nosaukums',
    usernameNvme: 'Etiķete',
    usernameCephx: 'Klienta nosaukums',
    usernameHint: 'Neobligāts konts, kuram noslēpums pieder',
    usernameHintChap: 'CHAP nosaukums, ar kuru initiator autentificējas',
    usernameHintNvme: 'Transports to neizmanto — brīva etiķete jūsu piezīmēm',
    usernameHintCephx: 'cephx klienta nosaukums — prefikss client. tiek pieciests',
    secret: 'Noslēpums',
    secretHint: 'Tikai rakstīšanai: to izmanto patērētāji, vairs nekad netiek rādīts.',
    secretHintNvmeDhchap: 'Tikai rakstīšanai: DH-HMAC-CHAP host noslēpums kanoniskajā formā DHHC-1:xx:… — to izmanto patērētāji, vairs nekad netiek rādīts.',
    secretHintCephx: 'Tikai rakstīšanai: base64 cephx atslēga — to izmanto patērētāji, vairs nekad netiek rādīta.',
    secretEditHint: 'Jāatstāj tukšs, lai noslēpumu nemainītu — aizpildot to, tas tiek rotēts.',
    createdAt: 'Izveidoti',
    inUseError: 'Uz "{name}" atsaucas kāda storage konfigurācija — vispirms tie jāatvieno tur.',
    nameHint: 'Mazie burti, cipari un defises (DNS-1123); unikāls scope ietvaros',

    // Tikai rotācijas dialogs (kārta #156): noslēpumam nekad nav iekļautā zīmuļa.
    rotateTitle: 'Rotēt noslēpumu',
    rotateHint: 'Tikai rakstīšanai: jaunais noslēpums aizstāj saglabāto — patērētāji to izmantos nākamajā montēšanas reizē.',

    // Kārta #159 (PKI): cilnes Sertifikāti un CA.
    tabSecrets: 'Noslēpumi',
    tabCertificates: 'Sertifikāti',
    tabAuthorities: 'Sertifikācijas iestādes',
    certificatesTitle: 'Sertifikāti',
    authoritiesTitle: 'Sertifikācijas iestādes',
    caCreateTitle: 'Jauna CA',
    certCreateTitle: 'Jauns sertifikāts',
    caMode: 'Izcelsme',
    caModeGenerate: 'Ģenerēt ar TVirt',
    caModeImport: 'Importēt (atslēga + sertifikāts)',
    certMode: 'Izcelsme',
    certModeIssue: 'Izsniegt no kādas keystore CA',
    certModeImport: 'Importēt (atslēga + sertifikāts)',
    issuingCa: 'Izsniedzēja CA',
    issuingCaHint: 'Sertifikāts rodas CA scope, ar reģistrētu vecāku',
    noCasHint: 'Keystore nav nevienas CA — vispirms tāda jāģenerē vai jāimportē cilnē CA',
    commonName: 'Common name (CN)',
    commonNameCaHint: 'CA subject: burti, cipari, atstarpe, punkts, pasvītrojums, defise',
    commonNameCertHint: 'OpenVPN identificē klientus pēc CN — tas jātur unikāls katrai CA',
    days: 'Derīgums (dienās)',
    daysCaHint: '1–7300 dienas; 3650 (10 gadi) ir noklusējums',
    daysCertHint: '1–3650 dienas; 365 ir noklusējums',
    keyType: 'Atslēgas tips',
    keyTypeHint: 'EC P-256 ir noklusējums; RSA legacy patērētājiem',
    usage: 'Lietojums',
    usageClient: 'Klients (clientAuth)',
    usageServer: 'Serveris (serverAuth)',
    usageHint: 'Extended key usage, kuram sertifikāts tiek izsniegts',
    san: 'Alternatīvie nosaukumi (SAN)',
    sanHint: 'Atdalīti ar komatu; burtiskas IP adreses kļūst par IP: ierakstiem, pārējie par DNS:',
    keyPem: 'Privātā atslēga (PEM)',
    keyPemHint: 'Tikai rakstīšanai: glabāta keystore, vairs nekad netiek rādīta',
    certPem: 'Sertifikāts (PEM)',
    certPemHint: 'Publiskais sertifikāts, kas savienojas pārī ar atslēgu',
    certPemCaHint: 'CA sertifikāts, kas savienojas pārī ar atslēgu (basicConstraints CA)',
    subject: 'Subject',
    issuer: 'Izsniedzējs',
    parentCa: 'Izsniedzēja CA',
    parentCaImported: 'Importēts — izsniegts ārpus TVirt',
    serial: 'Sērijas numurs',
    fingerprint: 'Nospiedums (SHA-256)',
    validFrom: 'Derīgs no',
    validUntil: 'Derīgs līdz',
    expiry: 'Derīguma termiņš',
    expired: 'Beidzies',
    expiresInDays: 'Beidzas pēc {days} d',
    revoked: 'Atsaukts',
    revokedAtLabel: 'Atsaukts',
    revokeTitle: 'Atsaukt sertifikātu',
    revokeAction: 'Atsaukt',
    revokeWarning: 'Atsaukšana ir galīga: sērijas numurs nonāk izsniedzējas CA CRL sarakstā, un katrs patērētājs, kas noraida atsauktus sertifikātus (pirmām kārtām OpenVPN), šo noraidīs. Atsaukumu atcelt nav iespējams.',
    exportPem: 'Eksportēt PEM',
    exportChain: 'Eksportēt ķēdes komplektu',
    exportCrl: 'Eksportēt CRL',
    materialImmutableHint: 'X.509 materiāls ir nemainīgs — jāizsniedz vai jāimportē no jauna',
    caInUseError: '"{name}" vēl ir dzīvi izsniegti sertifikāti (vai uz to atsaucas kāds storage) — vispirms tie jāatsauc vai jādzēš.'
  },
  proximity: {
    title: 'TVirt Proximity',
    subtitle: 'Izvietojums, pieejamība un afinitāte — kur darbojas klastera VM un vai tām jābūt ieslēgtām',
    loadError: 'Proximity panelim nepieciešams klastera store — flotes stāvoklis pašlaik nav sasniedzams',
    config: {
      title: 'Konfigurācija',
      subtitle: 'Izvietošanas politika klastera līmenī',
      save: 'Saglabāt',
      saveError: 'Konfigurācija tika noraidīta',
      strategy: 'Atlases stratēģija',
      strategy_leastUsedResources: 'Vismazāk izmantotie resursi',
      strategy_leastVms: 'Vismazāk VM',
      strategy_random: 'Nejauši',
      strategyLeastUsedResourcesHint: 'Starp derīgajiem kandidātiem — mezgls ar vislielāko atlikušo lietojamo RAM (novērotais kopapjoms − hosta rezerve − ieslēgtās VM), vCPU saistības kā izšķīrējs. Pie vienādiem datiem deterministiska.',
      strategyLeastVmsHint: 'Starp derīgajiem kandidātiem — mezgls ar vismazāk ieslēgtajām VM; vienādību izšķir pēc nosaukuma. Pie vienādiem datiem deterministiska.',
      strategyRandomHint: 'Vienmērīgi nejauši starp derīgajiem kandidātiem.',
      liveness: 'Mezglu dzīvīguma slieksnis (sekundēs)',
      livenessHint: 'Dalībnieks, kas klusē ilgāk par slieksni, ir nesasniedzams: izslēgts no izvietošanas un — ja nav apkopē — HA lēmējs to uzskata par mirušu, norobežo un pārstartē tā HA VM citur.',
      decider: 'HA lēmējs',
      deciderNone: 'vēl nav ievēlēts'
    },
    nodesTitle: 'Mezgli',
    nodesSubtitle: 'Dzīvīgums un empīriskā kapacitāte — lietojamā RAM = kopapjoms − pamats − saistītā',
    nodeCol: 'Mezgls',
    stateCol: 'Stāvoklis',
    ramCol: 'RAM (kopapjoms − pamats − saistītā)',
    usableCol: 'Lietojamā',
    vmsCol: 'Slodze',
    neverSeen: 'nekad nav redzēts',
    freshChip: 'sasniedzams',
    staleChip: 'nesasniedzams',
    attestedChip: 'apliecināts izslēgts',
    ramFormula: 'kopapjoms − pamats − saistītā',
    haTitle: 'Augsta pieejamība',
    haSubtitle: 'VM ar HA karodziņu ir "vienmēr ieslēgtas": TVirt tās pārstartē pēc katras neprasītas apturēšanas — tas pats mezgls ar backoff, cits mezgls, kad to mezgls nomirst (tikai koplietots storage).',
    haNone: 'Nevienai VM vēl nav HA karodziņa — to ieslēdz šeit vai VM detaļās.',
    haVmCol: 'Virtuālā mašīna',
    haStateCol: 'Stāvoklis',
    haRestartsCol: 'HA pārstartēšanas',
    haLastEventCol: 'Pēdējais notikums',
    haToggleCol: 'HA',
    haCrashLoop: 'crash loop',
    haToggleError: 'HA izmaiņa tika noraidīta',
    rules: {
      title: 'Afinitātes noteikumi',
      createTitle: 'Jauns Proximity noteikums',
      editTitle: 'Rediģēt noteikumu',
      nameHint: 'Mazie burti, cipari un defises (DNS etiķete)',
      vms: 'Virtuālās mašīnas',
      vmsHint: 'Vismaz divas VM — noteikums ierobežo, kur tās darbojas cita attiecībā pret citu',
      type: 'Tips',
      affinity: 'Afinitāte (kopā)',
      antiAffinity: 'Antiafinitāte (atsevišķi)',
      typeAffinityHint: 'VM jādarbojas uz VIENA UN TĀ PAŠA mezgla.',
      typeAntiAffinityHint: 'VM jādarbojas uz DAŽĀDIEM mezgliem — klasiskais HA pāris.',
      mode: 'Režīms',
      hard: 'hard',
      soft: 'soft',
      modeHardHint: 'Pārkāpumi atsaka operāciju (startēšanu, migrāciju, failover) ar runīgu kļūdu.',
      modeSoftHint: 'Priekšroka, nekad ne bloķējoša: izvietojums pārkāpumā turpinās ar redzamu brīdinājumu.',
      satisfied: 'Izvietojums',
      satisfiedYes: 'ievērots',
      satisfiedNo: 'pārkāpts',

      // Standarta dialogs (kārta #156): pārkāpumiem ir sava rinda, nevis tooltip.
      violations: 'Pārkāpumi',
      noViolations: 'Nav'
    },
    events: {
      title: 'HA notikumi',
      subtitle: 'Pieejamības žurnāls — pārstartēšanas, fencing, failover un godīgie izlaidumi',
      none: 'Vēl nekā.',
      when: 'Kad',
      kind: 'Notikums',
      target: 'Objekts',
      detail: 'Detaļas',
      kindRestarted: 'HA pārstartēšana',
      kindGaveUp: 'padošanās (crash loop)',
      kindNodeAttested: 'mezgls norobežots',
      kindFailedOver: 'failover',
      kindNoCandidate: 'nav kandidāta',
      kindStorageLocalSkip: 'izlaista (lokāls storage)',
      kindZombieFenced: 'zombijs izbeigts'
    }
  }
}
